import React from "react";

const APHCharts = () => {
  const powerBIUrl = "https://app.powerbi.com/view?r=eyJrIjoiNjA0M2M2NGItNTNmZC00ZTg5LTkyYjAtNjZlZjE4ZjViZGU3IiwidCI6IjM2NTdlZDI3LTliYTgtNGYyMS04YzVmLTVjOTI0ZTg2ZDMzNyJ9";

  return (
    <div>
      <iframe
        title="APH Charts"
        style={{
          width: "100%",
          height: "90vh"
        }}
        src={powerBIUrl}
        frameBorder="0"
        allowFullScreen
      />
    </div>
  );
};

export default APHCharts;